import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { IGlobalState } from '..';
import { PAGE } from '../../constants';

/** Определяет группы страниц по признаку */
export const useIsPage = () => {
    const { page } = useSelector((state: IGlobalState) => state.selection, isEqual);

    const isGuidCallCenterPage = useMemo(
        () => [PAGE.CALLCENTER, PAGE.CALLCENTER_MAIN_FORM_EDIT].includes(page),
        [page],
    );

    const isCallCenterPage = useMemo(
        () => [PAGE.CALLCENTER, PAGE.CALLCENTER_MAIN_FORM_EDIT, PAGE.CALLCENTER_FULL_PATH].includes(page),
        [page],
    );

    const isWlPage = useMemo(() => [PAGE.WHITELABEL, PAGE.CARDS_WHITELABEL].includes(page), [page]);

    const isRestoreUserPage = useMemo(() => [PAGE.RESTORE, PAGE.CARDS_RESTORE].includes(page), [page]);

    const isMainPage = useMemo(() => [PAGE.LANDING].includes(page), [page]);

    const isMainCreditCardPage = useMemo(() => [PAGE.CARDS_LANDING].includes(page), [page]);

    const isWaybackPage = useMemo(() => [PAGE.WAYBACK].includes(page), [page]);

    return useMemo(
        () => ({
            /** Callcenter использует guid для загрузки заявок */
            isGuidCallCenterPage,
            isCallCenterPage,
            isWlPage,
            isMainPage,
            isRestoreUserPage,
            isMainCreditCardPage,
            isWaybackPage,
        }),
        [
            isGuidCallCenterPage,
            isCallCenterPage,
            isWlPage,
            isMainPage,
            isRestoreUserPage,
            isMainCreditCardPage,
            isWaybackPage,
        ],
    );
};

export const useIsDisabledDownloadAppBanner = () =>
    useSelector(({ selection }: IGlobalState) => selection.disableMobileAppBanner);

export const useIsEnabledDownloadAppBanner = () =>
    useSelector(({ selection }: IGlobalState) => !selection.disableMobileAppBanner);
